import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import scheduleMods from "data/schedule-mods";
import {
    setLoading,
    fetchMapView,
    setScheduleActivate,
    setScheduleDeactivate,
    deleteScheduleActivate,
    scheduleExport,
    requestPatchSchedule,
    requestPatchScheduling,
    requestHighlightSchedule,
    clearScheduleList,
} from "api/menu/schedule/actions";

import {
    requestUnSubmitSchedule
} from "api/menu/reporting/actions";

import {
    closeCustomModal,
    openCustomModal
} from "components/custom/modals";

import SchedulingNewFilters from "components/menu/scheduling/filter/new-filters";
import AzureMapComponent from "./azure-map";

class SchedulingMap extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.state = {
            activeFilters: {
                earliestDate: moment().startOf("month").format("YYYY-MM-DD"),
                latestDate: moment().endOf("month").format("YYYY-MM-DD"),
                mode: {
                    label: scheduleMods.Submitted.title,
                    value: scheduleMods.Submitted.value
                }
            },
            requestParams: {}
        };

        this.handleFilterCallback = this.handleFilterCallback.bind(this);
        this.searchByFilters = this.searchByFilters.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
    }

    handleFilterCallback = (filterKey, value, isArray, callback = false) => {
        const activeFilters = Object.assign({}, this.state.activeFilters);
        activeFilters[filterKey] = value;

        this.setState({
            activeFilters
        }, () => {
            if (filterKey === "mode") {
                this.props.history.push(`/schedules/mapMaintenance/Submitted`);
                this.checkCanSearch(activeFilters, this.searchByFilters);
            } else if (typeof callback === "function") {
                callback();
            }
        });
    };

    checkCanSearch = (activeFilters, callback) => {
        if (activeFilters.mode) {
            if (activeFilters.mode.value === scheduleMods.Open.value) {
                if (
                    activeFilters.earliestDate !== null &&
                    activeFilters.latestDate !== null
                ) {
                    callback();
                }
            } else {
                callback();
            }
        }
    };

    resetFilters(callback = false) {
        this.setState({
            activeFilters: {}
        }, () => {
            if (typeof callback === "function") {
                callback();
            } else {
                this.searchByFilters();
            }
        });
    }

    searchByFilters() {
        this.checkCanSearch(this.state.activeFilters, () => {
            this.handleDataFetch();
        });
    }

    componentWillUnmount() {
        this.props.clearScheduleList();
    }

    handleDataFetch = () => {
        const { activeFilters } = this.state;
        const requestParams = {};

        // Process filters
        const notNeedFloatArr = ["traits", "exceptions", "mode", "category", "serviceConfirmation"];
        Object.keys(activeFilters).forEach((key) => {
            const parseFloatValue = notNeedFloatArr.indexOf(key) === -1;
            requestParams[key] = null;
            if (key === "serviceConfirmation") {
                requestParams[key] = activeFilters[key];
            } else if (activeFilters[key] !== null && typeof activeFilters[key] === "string") {
                requestParams[key] = activeFilters[key];
            } else if (activeFilters[key] !== null && activeFilters[key].value) {
                requestParams[key] = activeFilters[key].value;
                if (parseFloatValue) {
                    requestParams[key] = parseFloat(requestParams[key]);
                }
            } else if (Array.isArray(activeFilters[key]) && activeFilters[key].length) {
                requestParams[key] = activeFilters[key].map(item => {
                    if (parseFloatValue) {
                        return parseFloat(item.value);
                    }
                    return item.value;
                });
            }
        });

        this.setState({ requestParams });
        this.props.fetchMapView(requestParams);
    };

    render() {
        const { activeFilters } = this.state;
        const { mapListOptions, mapList, loading } = this.props;

        if (!activeFilters.mode && this.props.match.params.mode) {
            activeFilters.mode = {
                label: scheduleMods[this.props.match.params.mode].title,
                value: scheduleMods[this.props.match.params.mode].value
            };
        }

        return (
            <div className="dashboard">
                <SchedulingNewFilters
                    title="Scheduling Map"
                    titleFilteredCounts={{
                        totalFilteredRecords: mapListOptions.totalFilteredRecords || 0,
                        totalRecords: mapListOptions.pageSize || 0
                    }}
                    filters={mapListOptions.metadata}
                    activeFilters={{
                        ...activeFilters,
                        mode: {
                            label: scheduleMods.Submitted.title,
                            value: scheduleMods.Submitted.value
                        }
                    }}
                    filterCallback={this.handleFilterCallback}
                    onSearch={this.searchByFilters}
                    onReset={this.resetFilters}
                    onCheckCanSearch={this.checkCanSearch}
                    disableModeFilter={true}
                    hideExceptionsFilter={true}
                />

                {/* Azure Maps Component */}
                <div style={{ marginTop: '20px' }}>
                    <AzureMapComponent
                        apiKey="2UDHfGfZiW3lFe9K1fsjicZSFhdAgpxbDrE7vx3RP62ULifZmUhkJQQJ99AFACYeBjFvK8MrAAAgAZMPpqng"
                        mapData={mapList}
                        loading={loading}
                    />
                </div>
            </div>
        );
    }
}

SchedulingMap.propTypes = {
    fetchMapView: PropTypes.func.isRequired,
    clearScheduleList: PropTypes.func.isRequired,
    mapList: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    mapListOptions: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    user: state.auth.user,
    userRole: state.auth.user.role,
    mapList: state.schedule.mapList,
    mapListOptions: state.schedule.mapListOptions,
    loading: state.schedule.loading
});

const mapStateToDispatch = dispatch => ({
    setLoading: bindActionCreators(setLoading, dispatch),
    fetchMapView: bindActionCreators(fetchMapView, dispatch),
    clearScheduleList: bindActionCreators(clearScheduleList, dispatch),
    setScheduleActivate: bindActionCreators(setScheduleActivate, dispatch),
    setScheduleDeactivate: bindActionCreators(setScheduleDeactivate, dispatch),
    scheduleExport: bindActionCreators(scheduleExport, dispatch),
    deleteScheduleActivate: bindActionCreators(deleteScheduleActivate, dispatch),
    requestPatchSchedule: bindActionCreators(requestPatchSchedule, dispatch),
    requestPatchScheduling: bindActionCreators(requestPatchScheduling, dispatch),
    requestHighlightSchedule: bindActionCreators(requestHighlightSchedule, dispatch),
    requestUnSubmitSchedule: bindActionCreators(requestUnSubmitSchedule, dispatch),
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(SchedulingMap);
